/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedFormatListResponse } from '../types/PaginatedFormatList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type FormatsListRequest = {} | null | undefined;
export type FormatsListResponse = PaginatedFormatListResponse;

export type FormatsListQuery = {
  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;
};

/**
 * GET /dmx-server/formats/
 *
 * ```yaml
 * operationId: formats_list
 * tags:
 *   - formats
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedFormatList'
 *     description: ''
 * ```
 */
export const formatsListOperation = (rest?: FormatsListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/formats/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/formats/' };
  };

/**
 * GET /dmx-server/formats/
 *
 * ```yaml
 * operationId: formats_list
 * tags:
 *   - formats
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedFormatList'
 *     description: ''
 * ```
 */
export const formatsList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: FormatsListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedFormatListResponse>> => {
  const operation = formatsListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/formats/
 */
export const useFormatsListResource = (
  query: FormatsListQuery | null,
  useCached?: boolean,
): UseResource<FormatsListResponse> => {
  return useResource<FormatsListResponse>({
    path: query === null ? null : formatsListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
